let getAccessTokenSilently = null;

const obj = {
  getFn: () => getAccessTokenSilently,
  setFn: (fn) => { getAccessTokenSilently = fn; },
};

export default obj;
